__turbopack_context__.v({
  "ad-article-halfbanner": "_1v-EXa_ad-article-halfbanner",
  "ad-article-lleaderboard": "_1v-EXa_ad-article-lleaderboard",
  "button-article": "_1v-EXa_button-article",
  "detail": "_1v-EXa_detail",
  "header-article": "_1v-EXa_header-article",
  "section": "_1v-EXa_section",
  "subTitle": "_1v-EXa_subTitle",
  "title": "_1v-EXa_title",
  "wrapper": "_1v-EXa_wrapper",
});
